import styles from "./EllipseComponent.module.css";

const EllipseComponent = (props) => {
  return (
    <div className={styles.container}>
      {/* {["One", "Two", "Three"].map((text, index) => ( */}
        <div className={styles.ellipseWrapper}>
          <div className={styles.ellipse}>{props.ellipseText}</div>
          <p className={styles.label}>{props.labelText}</p>
        </div>
      {/* ))} */}
    </div>
  );
};

export default EllipseComponent;